import { render } from "./formgroup2.vue?vue&type=template&id=00dd2f9c"
import script from "./formgroup2.vue?vue&type=script&lang=js"
export * from "./formgroup2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__